import ModalContainer from "../../../containers/Modal/ModalContainer";
import { usePrecandidateContext } from "../context/Context";
import CreatePrecandidate from "./CreatePrecandidate";
import { useTranslation } from "react-i18next";
import "./stylesCreate.scss";
import { useState } from "react";
import { PreCandidateService } from "../../../services/PreCandidate";
import { toast } from "react-toastify";

const ModalCreatePrecandidate = ({ setMassImportPrecandidate }) => {
  const {
    modalShow,
    setModalShow,
    setPrecandidate,
    precandidate,
    validatePreCandidate,
    createPrecandidatecallbackError,
    setUpdatePreCandidateList,
    updatePreCandidateList,
    onCloseForm,
    setErros
  } = usePrecandidateContext();
  const { t } = useTranslation();
  const [submitButtonIsDisabled, setSubmitButtonStatus] = useState(false);
  const closeModal = () => {
    setErros({});
    setModalShow(false);
  };
  const handleClear = () => {
    setPrecandidate({
      fullName: "",
      emailAddress: "",
      phoneNumber: "",
      managerId: 0,
      comment: "",
      cv: "",
      companyId: 0
    });
    setErros({});
  };
  const submissionStatus = { sucess: true, fail: false };
  const CreatePreCandidate = (event) => {
    event.preventDefault();
    if (!validatePreCandidate()) {
      setSubmitButtonStatus(false);
      return submissionStatus.fail;
    }
    let _preCandidate = { ...precandidate };
    _preCandidate.phoneNumber = _preCandidate.phoneNumber?.trim();
    setPrecandidate(_preCandidate);
    if (_preCandidate.businessAreas?.length > 0)
      _preCandidate.businessAreas = _preCandidate.businessAreas.map(
        (item) => item.id
      );

    PreCandidateService.CreatePrecandidate(
      _preCandidate,
      createPrecandidatecallbackError
    )
      .then((res) => {
        if (res && res.error) return submissionStatus.fail;
        setUpdatePreCandidateList(!updatePreCandidateList);
        setModalShow(false);
        onCloseForm();
        toast.success(t("Successfully saved"));
      })
      .finally(() => {
        setSubmitButtonStatus(false);
      });
    return submissionStatus.sucess;
  };

  const onSubmit = (event) => {
    setSubmitButtonStatus(true);
    let submited = CreatePreCandidate(event);
    if (setMassImportPrecandidate && submited)
      setMassImportPrecandidate({ ...precandidate });
  };

  return (
    <ModalContainer
      modalTitle={t("New Pre-Candidate")}
      closeModal={closeModal}
      crossmarkAction={closeModal}
      cancelButtonTitle={t("Clear")}
      cancelButtonAction={handleClear}
      submitButtonTitle={t("Done")}
      submitButtonType="submit"
      submitButtonAction={onSubmit}
      submitButtonDisabled={submitButtonIsDisabled}
      isOpen={modalShow}
      modalSize="xl"
    >
      <CreatePrecandidate />
    </ModalContainer>
  );
};

export default ModalCreatePrecandidate;
